export default __webpack_public_path__ + "static/media/MBCorpoATitleCond-Regular.5502cd97.otf";